module.exports = __webpack_public_path__ + "img/farmasi_dan_kimia.8fc82853.svg";